/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, BuilderUserContext } from '@gh/builder-shared';
import { BuilderPermissionSet, OfficeType } from '@gh/builder-shared-data';
import { AppRouter, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { controlTracker, RouteDataService, SlicedDataSource } from '@gh/core-data';
import { cursorTracker, newGridPaginationCursor } from '@gh/core-ui-grid';
import { UserListBusinessService } from '../../resources/user-list-business.service';
import { UserListItem } from '../../resources/user-list-item.model';
import { UserGridDefinition } from './user-grid-definition.service';
import { newFormControl } from '@gh/core-ui';

@Component({
  standalone: false,
  selector: 'gh-user-list-tab',
  templateUrl: 'user-list-tab.component.html',
  styleUrls: ['user-list-tab.component.scss'],
  providers: [UserGridDefinition],
})
export class UserListTabComponent implements OnInit {
  dataSource: SlicedDataSource<UserListItem>;
  cursor = newGridPaginationCursor();
  showInactive = newFormControl(false);

  constructor(
    private router: AppRouter,
    private route: ActivatedRoute,
    private routeData: RouteDataService,
    private navigationService: BuilderNavigationService,
    private businessService: UserListBusinessService,
    public gridDefinition: UserGridDefinition,
    private userContext: BuilderUserContext,
  ) {
  }

  get isTemplateOffice(): boolean {
    const { office } = this.userContext;
    return office ? office.type === OfficeType.Template : false;
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { gridLayout } = getRouteInitData(this.route);
    this.gridDefinition.bind(gridLayout);

    const tracker = this.routeData.tracker(controlTracker(this.showInactive)).withEffects(cursorTracker(this.cursor));
    tracker.listen(this.route);
    tracker.filterChanges.subscribe(() => {
      this.loadData();
    });
  }

  onCreate(): void {
    this.router.navigateToChild(['/setup/users/new']);
  }

  onEdit(user: UserListItem): void {
    if (this.userContext.hasPermission(BuilderPermissionSet.Setup.Manager.UserDetails.EDIT_VIEW)) {
      this.router.navigateToChild(['/setup/users', user.userId]);
    }
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    this.navigationService.goToAel({
      entityId: entityId ? entityId : undefined,
      entityType: entityType ? entityType : 'USER',
      label: label ? label : 'lbl_users_list',
    });
  }

  private loadData(): void {
    this.dataSource = this.businessService.findAllAsDataSource(this.showInactive.value);
  }

}
